
import { API_BASE,axiosApi } from "../config"
import {
  DropboxInterface,
  GeneralReturnInterface,
  GetDropboxesReturnInterface
} from "../types"



export const getDropboxes = async (): Promise<GetDropboxesReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/getDropboxes`)).data
}


export const updateDropbox = async (body:{dropbox:DropboxInterface}): Promise<GeneralReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/updateDropbox`,body)).data
}
